import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import VisibilitySensor from 'react-visibility-sensor';

import { CONTACT_US_BUTTON_IMPRESSION } from 'lib/analytics/events';

export const PROMPT_STEP = 'Prompt';

const propTypes = {
  step: PropTypes.string.isRequired,
  contact: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

class MonthlyFormPrompt extends Component {
  constructor(props) {
    super(props);

    this.trackButtonImpression = this.trackButtonImpression.bind(this);
  }

  trackButtonImpression() {
    this.props.trackEvent(CONTACT_US_BUTTON_IMPRESSION);
  }

  render() {
    const { contact, step } = this.props;
    if (step !== PROMPT_STEP) { return null; }

    return (
      <Fragment>
        <div className="row margin-bottom-10 text-color-dark-slate text-center">
          <div className="col-xs-12 text-size-16 text-weight-bold">
            <FormattedMessage
              id="search.decisions"
              defaultMessage="DECISIONS, DECISIONS"
            />
          </div>
        </div>
        <div className="row margin-bottom-10 text-color-dark-slate text-center">
          <div className="col-xs-10 col-xs-offset-1 text-size-14 text-weight-book">
            <FormattedMessage
              id="search.monthly-prompt"
              defaultMessage="Need a hand choosing the right monthly parking for your needs? We're here to help."
            />
          </div>
        </div>
        <div className="row margin-bottom-30">
          <div className="col-xs-4 col-xs-offset-4">
            <VisibilitySensor onChange={this.trackButtonImpression}>
              <button className="btn btn-primary btn-blue" onClick={contact}>
                <FormattedMessage
                  id="common.contact-us"
                  defaultMessage="CONTACT US"
                  className="text-size-14"
                />
              </button>
            </VisibilitySensor>
          </div>
        </div>
      </Fragment>
    );
  }
}

MonthlyFormPrompt.propTypes = propTypes;
export default MonthlyFormPrompt;
